import * as React from 'react';
import { Element } from 'slate';
import { useFocused, useSelected } from 'slate-react';
import styled from 'styled-components';
import DisplayText from '@sdk/components//ui/DisplayText';

type MentionContainerProps = {
  focused: boolean;
  selected: boolean;
};

const MentionContainer = styled.span<MentionContainerProps>`
  margin: 0;
  display: inline-block;
  border-radius: 4px;
  box-shadow: ${(props): string =>
    props.selected && props.focused ? '0 0 0 2px #B4D5FF' : 'none'};

  ${DisplayText} {
    font-size: 14px;
    color: ${({ theme }): string => theme.colors.primary};
  }
`;

type Props = {
  attributes: any;
  element: Element;
};

const Mention: React.FC<React.PropsWithChildren<Props>> = ({ attributes, element, children }) => {
  const selected = useSelected();
  const focused = useFocused();
  if (element.type !== 'mention') {
    return null;
  }

  return (
    <MentionContainer selected={selected} focused={focused} {...attributes} contentEditable={false}>
      <DisplayText>@{element.displayName}</DisplayText>
      {children}
    </MentionContainer>
  );
};

export default Mention;
